import { PendingChangeOrderInitiatedBy } from '../enums/pending-change-order-initiated-by'
import { PendingChangeOrderPricingMethod } from '../enums/pending-change-order-pricing-method'
import { PendingChangeOrderWorkType } from '../enums/pending-change-order-work-type'

export class PendingChangeOrder {
    id!: string
    job!: string
    description!: string
    isHot = false
    initiatedBy = PendingChangeOrderInitiatedBy.Owner
    dateInitiated?: Date
    workType = PendingChangeOrderWorkType.CriticalPath
    pricingMethod = PendingChangeOrderPricingMethod.TM
    approxCost?: number
    rfiNumber!: string
    ownerAcknowledgedDate?: Date
    wcdNumber!: string
    pcoNumber!: string
    ownerCoNumber!: string
    hbNumber!: string
    waitingOnQuotes!: string
    readyForApprovalDate?: Date
    programMgrApprovalDate?: Date
    vpApprovalDate?: Date
    sentToOwnerDate?: Date
    ownerAuthorizedDate?: Date
    ownerExecutedDate?: Date
    importedIntoVistaDate?: Date
    proceedToWork?: Date
    proceedToWorkByHrRef?: number | null
    notes!: string
    rawTranscription!: string
    createdOn?: Date
    createdByHrRef?: number | null
    archived!: boolean
    imageUrls!: string[]

    // Looked up from HcssApiEstimate (read-only, not in modal)
    estimatedHbCost?: number
    estimatedHbPrice?: number
    hbMarkup?: number
    hbOh?: number

    derivedStage?: string
    daysInStage?: number

    /** Display-only. Resolved on the client from the job's project manager; not stored on the server. */
    projectManagerName?: string
}

export interface PendingChangeOrderExtractionResult {
    job: string | null
    description: string | null
    notes: string | null
    initiatedBy?: string | null
}
